module.exports = __webpack_public_path__ + "static/12-16b4d378d628db363ce2f84cd9c95746.jpg";